import gql from 'graphql-tag'

export const newServiceCardFragment = gql`
  fragment NewServiceCard on NewServiceEntityResponseCollection {
    data {
      id
      attributes {
        pageTitle
        supportingText
        slug
        type
        featureImage {
          data {
            id
            attributes {
              alternativeText
              width
              height
              url
            }
          }
        }
      }
    }
  }
`
export const newServiceCardFragmentAlt = gql`
  fragment NewServiceCardAlt on NewServiceEntityResponse {
    data {
      id
      attributes {
        pageTitle
        slug
        type
        supportingText
        featureImage {
          data {
            attributes {
              alternativeText
              url
              width
              height
            }
          }
        }
      }
    }
  }
`

export const testimonialFragment = gql`
  fragment Testimonial on TestimonialEntityResponseCollection {
    data {
      id
      attributes {
        company
        companyImage {
          data {
            id
            attributes {
              url
              height
              width
            }
          }
        }
        authorDesignation
        authorName
        authorImage {
          data {
            id
            attributes {
              url
              height
              width
            }
          }
        }
        review
      }
    }
  }
`

export const testimonialFragmentAlt = gql`
  fragment Testimonial on TestimonialRelationResponseCollection {
    data {
      id
      attributes {
        company
        companyImage {
          data {
            id
            attributes {
              url
              height
              width
            }
          }
        }
        authorDesignation
        authorName
        authorImage {
          data {
            id
            attributes {
              url
              height
              width
            }
          }
        }
        review
      }
    }
  }
`

export const seoFragment = gql`
  fragment SEO on ComponentSeoSeo {
    title
    description
    canonical
    noIndex
    featuredImage {
      data {
        attributes {
          url
        }
      }
    }
    jsonSchema
  }
`

export const linkFragment = gql`
  fragment Link on ComponentSharedLink {
    id
    title
    href
    target
  }
`

export const simpleCardFragment = gql`
  fragment SimpleCard on ComponentCardsSimpleCard {
    id
    title
    description
    meta
    image {
      data {
        attributes {
          url
          alternativeText
          width
          height
        }
      }
    }
    icon {
      data {
        attributes {
          url
          alternativeText
          width
          height
        }
      }
    }
  }
`
export const imageCardFragment = gql`
  fragment ImageCard on ComponentCardsImageCard {
    id
    title
    description
    media {
      data {
        id
        attributes {
          url
          alternativeText
          width
          height
        }
      }
    }
    ctaLink
  }
`
export const linkCardFragment = gql`
  fragment LinkCard on ComponentCardsLinkCard {
    id
    name
    description
    url
    image {
      data {
        attributes {
          url
          alternativeText
          width
          height
        }
      }
    }
  }
`
export const timelineCardFragment = gql`
  fragment TimelineCard on ComponentCardsTimeline {
    title
    time
    image {
      data {
        attributes {
          url
          width
          height
        }
      }
    }
    pepperTimelineEvents {
      title
      description
    }
  }
`
export const pageHeroFragment = gql`
  fragment PageHero on ComponentSharedPageHero {
    id
    title
    description
    footnote
    image {
      data {
        id
        attributes {
          height
          width
          mime
          alternativeText
          url
        }
      }
    }
    videoLink
    primaryCta {
      id
      title
      href
      target
    }
    secondaryCta {
      id
      title
      href
      target
    }
  }
`
export const quoteTestimonial = gql`
  fragment QuoteTestimonial on ComponentTestimonialsQuoteTestimonial {
    id
    testimonials {
      id
      authorName
      authorDesignation
      authorCompany
      authorImage {
        data {
          id
          attributes {
            url
            alternativeText
            width
            height
          }
        }
      }
      review
      authorCompanyImage {
        data {
          id
          attributes {
            url
            alternativeText
            width
            height
          }
        }
      }
    }
    cta {
      id
      title
      href
      target
    }
  }
`
export const blockFragment = gql`
  fragment BlockFragment on ComponentSharedBlock {
    id
    title
    description
    color
    link {
      id
      title
      href
      target
    }
    multimedia {
      id
      media {
        data {
          id
          attributes {
            url
            alternativeText
            width
            height
          }
        }
      }
      url
    }
  }
`
export const blockExtendedFragment = gql`
  fragment BlockExtendedFragment on ComponentSharedBlockExtended {
    id
    title
    description
    color
    link {
      id
      title
      href
      target
    }
    multimedia {
      id
      media {
        data {
          id
          attributes {
            url
            alternativeText
            width
            height
          }
        }
      }
      url
    }
    additionalFields
  }
`
export const brandsFragment = gql`
  fragment Brands on ComponentSharedBrands {
    title
    brands {
      data {
        id
        attributes {
          name: Brand_Name
          logo: Logo {
            data {
              attributes {
                height
                width
                alternativeText
                url
              }
            }
          }
        }
      }
    }
  }
`

export const footerCTAFragment = gql`
  fragment FooterCTA on ComponentSharedFooterCta {
    id
    title
    description
    primaryCta {
      id
      title
      href
      target
    }
    secondaryCta {
      id
      title
      href
      target
    }
    list {
      id
      Item
    }
  }
`
export const multimediaFragment = gql`
  fragment MultiMedia on ComponentSharedMultiMedia {
    id
    media {
      data {
        id
        attributes {
          url
          alternativeText
          width
          height
        }
      }
    }
    url
  }
`
export const speakerDetailsCardFragment = gql`
  fragment SpeakerDetails on ComponentCardsSpeakerDetailsCard {
    id
    name
    description
    linkedinURL
    companyName
    tag
    image {
      data {
        id
        attributes {
          url
          alternativeText
          width
          height
        }
      }
    }
    companyImage {
      data {
        id
        attributes {
          url
          alternativeText
          width
          height
        }
      }
    }
  }
`
export const caseStudyCardFragment = gql`
  fragment CaseStudy on ComponentCardsCaseStudy {
    id
    testimonialContent
    customerName
    customerDesignation
    bannerImage {
      data {
        id
        attributes {
          url
          alternativeText
          width
          height
        }
      }
    }
    avatar {
      data {
        id
        attributes {
          url
          alternativeText
          width
          height
        }
      }
    }
    companyLogo {
      data {
        id
        attributes {
          url
          alternativeText
          width
          height
        }
      }
    }
    caseStudyCta {
      id
      title
      href
      target
    }
  }
`

export const caseStudyContentFragment = gql`
  fragment Content on ComponentSharedContent {
    id
    title
    subTitle
    description
  }
`
export const comparisonFragment = gql`
  fragment ComparisonFragment on ComponentSharedComparison {
    id
    featureTitle
    subFeatureDetails {
      id
      subFeatureTitle
      featureDescriptionForPepper
      isFeaturePresentForPepper
      featureDescriptionForComparedCompany
      isFeaturePresentForComparedCompany
    }
  }
`
